export const tryGetErrorMessage = (error: unknown, fallback?: string) => {
    return error instanceof Error
        ? error.message
        : typeof error === 'string'
          ? error
          : (fallback ?? 'Unknown error');
};
